export default "__VITE_ASSET__1dd7670f__"